//material events
export const CreateMaterialEvent: string = 'Create Material'
export const EditMaterialEvent: string = 'Edit Material'

//assembly events
export const CreateAssemblyEvent: string = 'Create Wall Assembly'
export const CreateAssemblyRibbonEvent: string = 'Create Ribbon Assembly'
export const CreateAssemblyWindowEvent: string = 'Create Window Assembly'
export const CreateAssemblyCurtainEvent: string = 'Create Curtain Assembly'
export const CreateAssemblyHorizontalEvent: string = 'Create Horizontal Assembly'
export const DuplicateAssemblyEvent: string = 'Duplicate Assembly'

//scenario events
export const CreateScenarioEvent: string = 'Create Scenario'

//project events
export const LoadProjectEvent: string = 'Load Project'